<template>
    <div class="card">
        <h1 class="card-header text-center">Search for a Health Plan</h1>
        <div class="card-body">
            <form @submit.prevent="submit" id="formData">
                <b-modal id="modal-confirm-plan" size="lg" no-close-on-backdrop hide-footer scrollable @hide="reset" class="mt-3">
                    <template slot="modal-header">
                        <h1>Plan Selected</h1>
                    </template>
                    <h2>Confirm Plan</h2>
                    <hr/>
                    <div>
                        <b-row>
                            <b-col cols="12">
                                <p v-if="this.selectedPlan.claimed">You have selected {{ this.selectedPlan.hccisId }}, {{ this.selectedPlan.name }}. This plan has already been selected by another user. If you believe this is in error, please contact the system administrator. Please select "Search Again" to change your selection.</p>
                                <p v-else>You have selected {{ this.selectedPlan.hccisId }}, {{ this.selectedPlan.name }}. Please select "Confirm" to make your selection, or "Search Again" to change your selection.</p>
                            </b-col>
                        </b-row>
                    </div>

                    <b-row style="padding-top: 10px;">
                        <b-col>
                            <b-button :disabled="this.selectedPlan.claimed" :hidden="this.selectedPlan.claimed" @click="confirmPlan(selectedPlan);goToPlan(selectedPlan.demographyId)" variant="primary" style="margin-right:15px;">Confirm</b-button>
                            <b-button @click="close" style="margin-right:15px;">Search Again</b-button>
                        </b-col>
                    </b-row>
                </b-modal>
                <div class="form-row">
                    <div class="form-group col-md-7">
                        <label for="search">Search on Health Plan Name, Health Plan ID, or NAIC Number:</label><br/>
                        <input id="search" required type="text" class="form-control"
                               v-model.trim="$v.searchIt.$model" :class="{'is-invalid': $v.searchIt.$error}" v-focus><p></p>
                        <strong>Please note: The initial search may take up to 30 seconds.</strong>
                        <strong>If your company is not found please contact MDH staff at health.drmreport@state.mn.us or 651-201-3572.</strong>
                        <div class="invalid-feedback">
                            <span v-if="!$v.searchIt.required">Search text is required</span>
                        </div>
                    </div>
                </div>

                <div v-if="!$v.searchIt.minLength || !$v.searchIt.required || $v.searchIt.invalid " class="invalid-feedback">Text needs to be entered</div>

                <b-button variant="primary" v-on:click="submit">Search</b-button>
            </form>
        </div>
        <div class="card-body" v-if="this.searchResponse != null">
            <b-table hover show-empty
                     id="searchResults"
                     responsive="true"
                     :items="this.searchResponse"
                     :fields="fields"
                     :per-page="perPage"
                     :current-page="currentPage"
                     :busy="isBusy"
            >
                <template slot="table-caption">
                    <p>To sort the data by a specific column type (Name, NAIC Number, etc.)
                        , navigate to the column header and use enter to sort the data ascending.
                        Use enter again to sort descending.</p>
                </template>
                <template v-slot:cell(choose)="row">
                    <b-button size="m" :disabled="false" @click="choosePlan(row.item)" class="mr-1 mb-3" variant="primary"
                              :aria-label="'Choose plan: ' + row.item.name">
                        Choose plan
                    </b-button>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div>
                <template slot="empty" slot-scope="scope">
                    No Items Found.
                </template>
            </b-table>
            <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="searchResults"
                    align="center"
                    size="sm"
                    class="my-0"
            ></b-pagination>
        </div>
    </div>
</template>

<script>

    import { required, minLength  } from 'vuelidate/lib/validators';
    import lambdaURL from '../lambda'
    import lambdaValidate from '../lambda3'

    export default {
        directives: {
            focus: {
                inserted: function (el) {
                    el.focus();
                }
            }
        },
        name: 'Search',
        data() {
            return {
                searchIt: '',
                hasError: false,
                searchResponse: null,
                selectedPlan: {
                    hccisId: null,
                    demographyId: null,
                    naic: null,
                    claimed: true
                },
                items: [],
                isBusy: false,
                fields: [
                    {key: 'choose', sortable: false, label: 'Choose This Plan?'},
                    {key: 'hccisId', sortable: true, label: 'Health Plan ID'},
                    {key: 'name', sortable: true, label: 'Name'},
                    {key: 'naic', sortable: true, label: 'NAIC Number'},
                ],
                currentPage: 1,
                perPage: 50,
            }
        },
        validations: {
            searchIt: {
                required, minLength: minLength(1)
            }
        },
        methods: {

            validationStatus: function(validation) {
                return typeof validation != "undefined" ? validation.$error : false;
            },

            submit() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.hasError = true;
                } else {
                    this.toggleBusy()
                    this.hasError = false;
                    /*lambdaURL.letsPingIt()*/
                    lambdaURL.searchTerm(this.searchIt).then((res) => {
                        this.searchResponse = res;
                        this.toggleBusy()
                    })
                        .catch((err) => {
                        })
                    /*window.location.replace('/plan');*/
                }

            },

            choosePlan(selectedPlan) {
                Object.assign(this.$data.selectedPlan, selectedPlan);
                selectedPlan.claimed = true;
                lambdaURL.getDemography(this.selectedPlan.demographyId, this.$keycloak.userName, this.$keycloak.fullName).then((res) => {
                    if (res.hccisId != null) {
                        this.selectedPlan.claimed = false
                        this.$bvModal.show('modal-confirm-plan')
                    }
                })
                    .catch((err) => {
                        this.$bvModal.show('modal-confirm-plan')
                    })
            },

            confirmPlan(selectedPlan) {
                Object.assign(this.$data.selectedPlan, selectedPlan);
                selectedPlan.claimed = true
                lambdaURL.confirmPlan(this.selectedPlan.demographyId, this.$keycloak.userName, this.$keycloak.fullName).then((res) => {
                    if (res.hccisId != null) {
                        this.selectedPlan.claimed = false
                        this.$bvModal.show('modal-confirm-plan')
                    }
                })
                    .catch((err) => {
                        this.$bvModal.show('modal-confirm-plan')
                    })

            },

            close () {
                this.$bvModal.hide('modal-confirm-plan')
            },

            reset() {
                this.selectedPlan = {
                    hccisId: null,
                    demographyId: null,
                    naic: null,
                    claimed: true
                };
                this.searchIt = '';
                this.searchResponse = null;
            },

            goToPlan(id) {
                this.$router.push('/demographicsForm/'+id)
            },

            toggleBusy(){
                this.isBusy = !this.isBusy
            },
        },

        computed: {
            rows() {
                return this.searchResponse.length
            }
        },

    }

</script>

<style>


</style>